import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse",
  "use": "icon-warehouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warehouse\"><path d=\"M640 725.333v-128h128v128h85.333v128h-128v-128h-42.666v128h-128v-128H640zm213.333-128H768v-51.2l-256-256-256 256V768h256v85.333H170.667V554.667H128l384-384 384 384h-42.667v42.666z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol